import { css, styled } from "@enfusion-ui/web-core";
export const ViewContainer = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;

  ~ .ag-popup .ag-menu {
    z-index: 110;
  }
`;
export const CenterContent = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ fillHeight = true }) => (fillHeight ? "height: 100%;" : "")}
  ${({ fillWidth = false }) => (fillWidth ? "width: 100%;" : "")}
`;
export const BoldText = styled.span `
  font-weight: bold;
`;
export const MutedText = styled.span `
  color: var(--text-muted);
`;
export const ACTION_BAR_HEIGHT = 28;
export const ViewContent = styled.div `
  overflow: hidden;
  ${({ pushUp = false }) => pushUp ? `margin-top: ${0 - ACTION_BAR_HEIGHT}px;` : ""}
  ${({ bordered = true }) => bordered ? "border: 1px solid var(--border);" : ""}
  ${({ fillWidth = false }) => (fillWidth ? "width: 100%;" : "")}
  ${({ fillHeight = true }) => (fillHeight ? "height: 100%;" : "")}
`;
export const TabTopActionBar = styled.div `
  height: ${({ thin }) => (thin ? 0 : ACTION_BAR_HEIGHT)}px;
  min-height: ${({ thin }) => (thin ? 0 : ACTION_BAR_HEIGHT)}px;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--background-color-2);
  ${({ bordered = false }) => bordered
    ? css `
          border: 1px solid var(--border);
          border-bottom-width: 0px;
        `
    : ""}
`;
export const AlignRightRow = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding-right: var(--spacing);
  ${({ flex }) => (flex ? "flex: 1;" : "")}
`;
export const SingleColumnGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
`;
export const SingleColumnGridWithGap = styled(SingleColumnGrid) `
  grid-gap: var(--spacing-xl);
  gap: var(--spacing-xl);
`;
export const WidthHeight100 = styled.div `
  width: 100%;
  height: 100%;
`;
export const SVGBackground = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;

  background-color: var(--background-color-2);
  background-image: var(--landing-bg);
  background-attachment: fixed;
  background-size: cover;
`;
export const ContentMessageWrapper = styled.div `
  display: flex;
  flex-flow: column;
  height: var(--xl-spacing);

  ${({ isConfigurable = true }) => (isConfigurable ? "cursor: pointer" : "")};
`;
